import { Environment } from "@/models";
import { EnvironmentDTO, GetEnvironmentBetweenRangeByMonitorIdResponseApiDto } from "../dtos";
import { orderDataByCreatedAt } from "../utils";

const mapperEnvironmentDTOToEnvironment = (environmentDTO: EnvironmentDTO): Environment => {
  return {
    createdAt: environmentDTO.createdAt,
    temperature: environmentDTO.temperature,
    humidity: environmentDTO.humidity,
    iaq: environmentDTO.iaq,
    voc: environmentDTO.voc,
    smokingProbability: environmentDTO.smokingProbability,
    pax: environmentDTO.pax,
  };
};

export const mapperEnvironmentsDTOToMonitors = (
  environmentDTO: GetEnvironmentBetweenRangeByMonitorIdResponseApiDto
): Environment[] => {
  const environments = environmentDTO.data.map(mapperEnvironmentDTOToEnvironment);
  return orderDataByCreatedAt(environments);
};
